import { Table, TableContainer, Thead, Tr, Th, Tbody, Td, Box, Button, SkeletonText } from "@chakra-ui/react"

import DeleteIcon from "@/assets/DeleteIcon";
import EditIcon from "@/assets/EditIcon";
import ActiveStatus from "@/assets/ActiveStatus";
import InactiveStatus from "@/assets/InactiveStatus";
import Pagination from "../Layouts/Pagination";
import { COLORS } from "@/common/constants";

const TableInvoiceTemplate = ({ dataList, isLoading, handleEdit, handleDelete, currentPageSize, handleChangePageSize, handleChangePageNumber, currentPageNumber, totalPageNumber, hasNextPage, handleDownload }: any) => {
    return (
        <TableContainer bgColor="#fff" borderRadius="13">
            <Box overflowX="auto">
                <Table variant='simple'>
                    <Thead>
                        <Tr>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Template Name</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Contact Person</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Indonesia Bank</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>International Bank</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Manager</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Status</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Preview</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Action</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {isLoading &&
                            <Tr>
                                <Td colSpan={8}>
                                    <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='3' />
                                </Td>
                            </Tr>
                        }
                        {(!isLoading && (!dataList || dataList.length === 0)) &&
                            <Tr>
                                <Td colSpan={8} textAlign="center">Data not found</Td>
                            </Tr>
                        }
                        {!isLoading && dataList?.map((item: any) => {
                            return (
                                <Tr key={item.id}>
                                    <Td>{item.templateName}</Td>
                                    <Td dangerouslySetInnerHTML={{ __html: item.contactPerson }} />
                                    <Td dangerouslySetInnerHTML={{ __html: item.indonesiaBank }} />
                                    <Td dangerouslySetInnerHTML={{ __html: item.internationalBank }} />
                                    <Td>{item.managerName}</Td>
                                    <Td>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            {item.isDefaultTemplate && <ActiveStatus />}
                                            {!item.isDefaultTemplate && <InactiveStatus />}
                                        </div>
                                    </Td>
                                    <Td>
                                        <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
                                            <Button bgColor='#0075BE' borderRadius='full' color='white' minHeight='20px' onClick={() => handleDownload(item.templateEN, 5)}>EN</Button>
                                            <Button bgColor='#079455' borderRadius='full' color='white' minHeight='20px' onClick={() => handleDownload(item.templateID, 5)}>ID</Button>
                                        </div>
                                    </Td>
                                    <Td>
                                        <div style={{ display: 'flex', cursor: 'pointer', gap: 8, justifyContent: 'center' }}>
                                            <EditIcon onClick={() => handleEdit(item.id)} />
                                            {!item.isDefaultTemplate && <DeleteIcon onClick={() => handleDelete(item.id)} />}
                                        </div>
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Tbody>
                </Table>
            </Box>
            <Pagination currentPageSize={currentPageSize} currentPageNumber={currentPageNumber} totalPageNumber={totalPageNumber} handleChangePageSize={handleChangePageSize} handleChangePageNumber={handleChangePageNumber} hasNextPage={hasNextPage} />
        </TableContainer>
    )
}

export default TableInvoiceTemplate;